
import { ellipsisString } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { RequestListCommodity } from "@/data/payload/api/CommodityApiRequest";
import { Commodity, CommodityCategoryData } from "@/domain/entities/Commodity";
import { debounce } from "lodash";
import { Options, prop, Vue } from "vue-class-component";
import { createFocusTrap } from "focus-trap";

class Props {
  modelValue = prop<any>({
    required: true
  });
  clientCountry = prop<any>({
    default: ""
  });
}

@Options({
  emits: ["close", "update:modelValue", "change"]
})
export default class CommodityModalAll extends Vue.with(Props) {
  dataRecommendedCommodities: Commodity[] = [];
  dataCommoditiesByCategory: Commodity[] = [];
  dataCommodityCategory: CommodityCategoryData[] = [];
  categorySelected = "";
  loadingRecommendedList = false;
  errorRecommendedList = false;
  dataSearchCommodities: Commodity[] = [];
  isFocused = false;
  selectedSearchItem = "";
  selectedRecommendedItem = "";
  selectedCategoryItem = "";
  focusTrap: any = null;

  mounted() {
    this.getCommodityRecommendedList();
    this.getCommodityCategoryList();
  }
  closeModal() {
    if (this.focusTrap) {
      this.focusTrap.deactivate();
      this.focusTrap = null;
    }
    this.$emit("close", false);
  }

  beforeDestroy() {
    if (this.focusTrap) {
      this.focusTrap.deactivate();
    }
  }

  onModalRef(event: any) {
    if (this.focusTrap || !event?.$el) return;
    this.initFocusTrap(event.$el);
  }

  async initFocusTrap(el: any) {
    await this.$nextTick();
    this.focusTrap = createFocusTrap(el, {
      escapeDeactivates: true,
      allowOutsideClick: true,
      returnFocusOnDeactivate: true,
      clickOutsideDeactivates: false,
      onDeactivate: this.closeModal
    });

    this.focusTrap.activate();
  }

  search = "";
  onSearch = debounce((event) => {
    const value = event.target.value;
    if (value.length >= 3 || !value) {
      this.onInput(value);
    }
  }, 500);
  async onInput(val: string) {
    this.search = val;
    this.selectedSearchItem = ""; // Clear selection when searching
    if (!val.length) {
      this.dataSearchCommodities = [];
    } else {
      const commodities = await CommodityController.getCommodityList(
        new RequestListCommodity({
          page: 1,
          limit: 100,
          commodityStatus: "active",
          search: val
        })
      );
      this.dataSearchCommodities = commodities.data;
    }
  }
  onFocus() {
    this.isFocused = true;
  }
  onBlur() {
    if (!this.dataSearchCommodities.length) {
      this.isFocused = false;
    }
  }
  async getCommodityRecommendedList() {
    try {
      this.loadingRecommendedList = true;
      const commodities = await CommodityController.getCommodityList(
        new RequestListCommodity({
          page: 1,
          limit: 100,
          commodityStatus: "active",
          isRecommendedOnly: true
        })
      );
      this.dataRecommendedCommodities = commodities.data;
    } catch {
      this.errorRecommendedList = true;
    } finally {
      this.loadingRecommendedList = false;
    }
  }
  async getCommodityCategoryList() {
    const commodityCategory: any = await CommodityController.getCommodityCategory();
    this.dataCommodityCategory = commodityCategory;
  }
  async getCommodityByCategoryList(categoryCode: string) {
    this.categorySelected = categoryCode;
    this.selectedCategoryItem = ""; // Clear selection when switching category
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        page: 1,
        limit: 100,
        commodityStatus: "active",
        commodityCategoryCode: categoryCode
      })
    );
    this.dataCommoditiesByCategory = commodities.data;
  }
  ellipsisText(val: string, length: number) {
    return ellipsisString(val, length);
  }
  isCategorySelected(val: string) {
    return val === this.categorySelected;
  }
  setChangeCommodity(val: any) {
    this.$emit("change", val);
  }
  onChoooseCommodity(val: any) {
    this.setChangeCommodity(val);
    this.closeModal();
  }
  get isLoadingCommodity() {
    return CommodityController.isLoading;
  }
  get isLoadingCommodityCategory() {
    return CommodityController.isLoadingCategory;
  }
  get errorCategory() {
    return CommodityController.errorCategory;
  }
  get isClientID() {
    const clientCountry = this.clientCountry;
    if (!clientCountry) return true;
    return clientCountry.toLowerCase() === "id";
  }
  get accountIsNonForeign() {
    return AccountController.accountData.countryCode.toLowerCase() === "id" && this.isClientID;
  }
}
